import axios from 'axios';
export const getPublicCertificate = async (minterApiRoot, id) => axios
    .get(`${minterApiRoot}/certificate/${id}`) //
    .then((output) => output.data);
export const getCertificateDetails = async (minterApiRoot, id, authToken) => axios
    .get(`${minterApiRoot}/certificate/${id}/details`, {
    headers: { authorization: authToken.value() },
}) //
    .then((output) => output.data);
export const batchGetCertificateDetails = async (minterApiRoot, ids, authToken) => axios
    .get(`${minterApiRoot}/certificate/batch/details`, {
    params: { ids: ids.join(',') },
    headers: { authorization: authToken.value() },
})
    .then((output) => output.data);
export const createAndRequestApproval = async (minterApiRoot, input, authToken) => axios
    .post(`${minterApiRoot}/mint`, input, {
    headers: { authorization: authToken.value(), 'Content-Type': 'application/json' },
})
    .then((output) => output.data);
export const requestApproval = async (minterApiRoot, //
id, authToken, requestedBy) => axios
    .post(`${minterApiRoot}/requestApproval/${id}`, {}, {
    params: { requested_by: requestedBy },
    headers: { Authorization: authToken.value() },
})
    .catch(handleErrors)
    .then(() => undefined);
export const reprocessCertificate = async (minterApiRoot, //
id, authToken) => axios
    .post(`${minterApiRoot}/schedule/retry/${id}`, undefined, {
    headers: { Authorization: authToken.value() },
})
    .then((output) => output.data);
export const revokeCertificate = async (minterApiRoot, //
id, authToken) => axios
    .post(`${minterApiRoot}/certificate/${id}/revoke`, undefined, {
    headers: { Authorization: authToken.value() },
})
    .then((output) => output.data);
export const deferCertificate = async (minterApiRoot, id, input, authToken) => axios
    .post(`${minterApiRoot}/certificate/${id}/defer`, input, {
    headers: { authorization: authToken.value(), 'Content-Type': 'application/json' },
})
    .then((output) => output.data);
export const abortCertificate = async (minterApiRoot, //
id, authToken) => axios
    .delete(`${minterApiRoot}/certificate/${id}`, {
    headers: { Authorization: authToken.value() },
})
    .catch(handleErrors)
    .then(() => undefined);
export const saveDraft = async (minterApiRoot, //
id, authToken) => axios.post(`${minterApiRoot}/draft/${id}`, //
{}, { headers: { Authorization: authToken.value() } });
export const registerSignature = async (minterApiRoot, input, authToken) => axios
    .post(`${minterApiRoot}/certificate/register-signature`, input, {
    headers: { authorization: authToken.value(), 'Content-Type': 'application/json' },
})
    .catch(handleErrors)
    .then((output) => output.data);
export const rejectSignature = async (minterApiRoot, input, authToken) => axios
    .post(`${minterApiRoot}/certificate/reject-signature`, input, {
    headers: { authorization: authToken.value(), 'Content-Type': 'application/json' },
})
    .catch(handleErrors)
    .then((output) => output.data);
export const resendApprovalRequest = async (minterApiRoot, id, authToken) => axios
    .post(`${minterApiRoot}/certificate/${id}/resend-approval-request`, '{}', {
    headers: { authorization: authToken.value() },
})
    .then((output) => output.data);
export var ApprovalRequestType;
(function (ApprovalRequestType) {
    ApprovalRequestType["AUTOMATIC"] = "AUTOMATIC";
    ApprovalRequestType["MANUAL"] = "MANUAL";
})(ApprovalRequestType || (ApprovalRequestType = {}));
export const isFullySigned = (status) => missingRequiredSignatures(status).length === 0;
export const missingRequiredSignatures = (status) => {
    if (status.signatureRejectedBy !== undefined)
        return [];
    const usersThatSigned = status.signaturesRegisteredBy.filter((x) => x.type === 'user').map((x) => x.value);
    return (status.signers ?? []).filter((required) => !usersThatSigned.includes(required.email));
};
export const requiredSignatureOf = (status, userEmail) => missingRequiredSignatures(status).find((missingSignature) => missingSignature.email === userEmail);
export const signatureResponseFor = (status, email) => status.signatureRejectedBy?.value === email
    ? 'rejected'
    : status.signaturesRegisteredBy.find((s) => s.value === email) !== undefined
        ? 'signed'
        : undefined;
export const approveChangeRequest = async (minterApiRoot, id, authToken) => axios
    .post(`${minterApiRoot}/certificate/${id}/update`, {}, {
    headers: { Authorization: authToken.value() },
})
    .then((response) => response.status === 202);
export const certificateFromToken = async (minterApiRoot, token, authToken) => axios
    .post(`${minterApiRoot}/verifyToken`, {
    token: token,
}, {
    headers: { Authorization: authToken.value() },
})
    .then((response) => {
    const payload = response.data;
    return payload.valid ? { id: payload.id, email: payload.email } : {};
});
export const rejectChangeRequest = async (minterApiRoot, id, authToken) => axios
    .delete(`${minterApiRoot}/certificate/${id}/update`, {
    headers: { Authorization: authToken.value() },
})
    .then((response) => response.status === 204);
export var StateType;
(function (StateType) {
    StateType["INITIAL"] = "Initial";
    StateType["DRAFT"] = "Draft";
    StateType["DEFERRED"] = "Deferred";
    StateType["APPROVAL_REQUESTED"] = "ApprovalRequested";
    StateType["APPROVED"] = "Approved";
    StateType["READY_TO_EMIT"] = "ReadyToEmit";
    StateType["SIGN_SCHEDULED"] = "SignScheduled";
    StateType["INTERVENTION_REQUESTED"] = "InterventionRequested";
    StateType["PRE_SIGNED"] = "PreSigned";
    StateType["SIGNED"] = "Signed";
    StateType["EMITTED"] = "Emitted";
    StateType["ABORTED"] = "Aborted";
    StateType["REVOKED"] = "Revoked";
    StateType["REPLACED"] = "Replaced";
    StateType["CHANGE_REQUESTED"] = "ChangeRequested";
    StateType["CHANGE_APPROVED"] = "ChangeApproved";
    StateType["CHANGE_REJECTED"] = "ChangeRejected";
    StateType["SIGNATURE_REQUESTED"] = "SignatureRequested";
    StateType["SIGNATURE_REGISTERED"] = "SignatureRegistered";
    StateType["SIGNATURE_REJECTED"] = "SignatureRejected";
})(StateType || (StateType = {}));
export const forgotCertificatePassword = async (minterApiRoot, certificateId, input) => axios
    .post(`${minterApiRoot}/requestForgotPassword/${certificateId}`, input, {
    headers: {
        'content-type': 'application/json',
    },
})
    .then((output) => output.data);
export const createCertificate = async (minterApiRoot, input, token) => axios
    .post(`${minterApiRoot}/certificate`, input, {
    headers: {
        'content-type': 'application/json',
        Authorization: token.value(),
    },
})
    .then((output) => output.data);
export const batchEmit = async (minterApiRoot, input, token) => axios
    .post(`${minterApiRoot}/certificate/batch-emit`, input, {
    headers: {
        'content-type': 'application/json',
        Authorization: token.value(),
    },
})
    .then((output) => output.data);
export class SdkMinter {
    minterApiRoot;
    tokenStore;
    constructor(minterApiRoot, tokenStore) {
        this.minterApiRoot = minterApiRoot;
        this.tokenStore = tokenStore;
    }
    async findSimilars(wallet, similarsReq) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        const params = new URLSearchParams();
        params.set('wallet', wallet);
        params.set('date', String(similarsReq.date));
        if (similarsReq.identification !== undefined) {
            params.set('identification', similarsReq.identification);
        }
        params.set('free', String(similarsReq.free));
        params.set('title', similarsReq.title);
        params.set('achiever', similarsReq.name);
        return axios
            .get(`${this.minterApiRoot}/certificate/similar`, {
            headers: { authorization: authToken.value() },
            params: params,
        })
            .then((output) => output.data);
    }
    async submitCertificate(input) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return createCertificate(this.minterApiRoot, input, authToken);
    }
    async deferCertificate(id, input) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return deferCertificate(this.minterApiRoot, id, input, authToken);
    }
    async saveCertificateDraft(id) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return saveDraft(this.minterApiRoot, id, authToken);
    }
    async requestApproval(id, requestedBy) {
        const authToken = await this.tokenStore.retrieveClientCredentials();
        return requestApproval(this.minterApiRoot, id, authToken, requestedBy);
    }
}
export class NoCreditsError extends Error {
}
export class InvalidTransition extends Error {
    constructor() {
        super();
    }
}
export var ConflictErrorCode;
(function (ConflictErrorCode) {
    ConflictErrorCode["INVALID_TRANSITION"] = "InvalidTransition";
})(ConflictErrorCode || (ConflictErrorCode = {}));
export const handleErrors = (e) => {
    const status = e.response.status;
    const errorCode = e.response.data.code;
    if (status === 400 && errorCode === 'NoCreditsError')
        throw new NoCreditsError();
    if (status === 409 && errorCode === ConflictErrorCode.INVALID_TRANSITION)
        throw new InvalidTransition();
    throw e;
};
//# sourceMappingURL=index.js.map